import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { belongsTo } from 'ember-data/relationships';
import CustomerModel from 'cio/models/customer';
import ObjectModel from 'cio/models/object';
import ApiService from 'cio/services/api';
import { inject as service } from '@ember/service';
import DS from 'ember-data';

export default class RelationshipModel extends Model {
  @service api!: ApiService;
  @service store!: DS.Store;

  @attr('number') created_at!: number;
  @attr('string') entity1Id!: string;
  @attr('string') entity1Type!: string;
  @attr('string') entity2Id!: string;
  @attr('string') entity2Type!: string;
  @attr({
    defaultValue: () => ({}),
  })
  attributes!: Record<string, any>;

  @belongsTo('customer', { async: false, inverse: 'relationships' }) customer!: CustomerModel;
  @belongsTo('object', { async: false, inverse: 'relationships' }) object!: ObjectModel;

  get attrs() {
    return Object.entries(this.attributes).map(([key, value]) => ({ [key]: value }));
  }

  async updateRelationship(attrs: Record<string, any>, hiddenAttributes: string[]) {
    let attributes = { ...attrs };

    hiddenAttributes.forEach((item) => {
      attributes[item] = '';
    });

    let relationship = {
      entity1_id: this.entity1Id,
      entity1_type: this.entity1Type,
      entity2_id: this.entity2Id,
      entity2_type: this.entity2Type,
      attributes,
    };

    await this.api.post(`relationships`, { data: { relationships: [relationship] } });

    // code below updates the relationship data in the store
    // casting to "any" because Ember serializers aren't typed correctly
    let serializer = (this.store.serializerFor as any)('relationship');

    for (let attributesKey of hiddenAttributes) {
      delete attributes[attributesKey];
    }

    let payload = {
      relationship: {
        ...relationship,
        attributes,
        id: this.id,
      },
    };
    // inspired by https://github.com/mike-north/ember-api-actions/blob/4c5bec481b622859dbe222224a04489f6c906b5b/addon/utils/serialize-and-push.ts#L33
    let normalized = serializer.normalizeSingleResponse(this.store, RelationshipModel, payload, this.id, 'query');
    return this.store.push(normalized);
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    relationship: RelationshipModel;
  }
}
